import CloseButton from "../CloseButton/CloseButton"
import styles from "./BottomSheet.module.scss"

interface Props {
  visible: boolean
  onClose?: () => void
  onClickOutside?: () => void
  containerClassName?: string
}

const BottomSheet = (props: React.PropsWithChildren<Props>) => {
  return (
    <>
      <div
        className={`${styles.bottomSheet} ${
          props.visible ? styles.visible : ""
        }`}
      >
        <div
          className={`${styles.bottomSheetContainer} ${
            props.containerClassName ?? ""
          }`}
        >
          {props.onClose && (
            <CloseButton
              className={styles.closeButton}
              onClick={props.onClose}
            />
          )}
          {props.children}
        </div>
      </div>
      <div
        onClick={props.onClickOutside}
        className={`${styles.backgroundDarken} ${
          props.visible ? styles.visible : ""
        }`}
      />
    </>
  )
}

export default BottomSheet
